import React from 'react';
import { findDOMNode } from 'react-dom';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classNames from 'classnames';
import CommentUtil from '../../util/CommentUtil';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import AnnotationUtil from '../../queries/annotations/AnnotationUtil';
import FileInfoUtil from '../../util/FileInfoUtil';
import StringUtil from '../../util/StringUtil';
import CommentReplies from './CommentReplies';
import Authenticator from '../../protocol/Authenticator';
import Action from '../../common/Action';
import { animateScroll } from '../../util/DOMUtil';
import AtMentionUserNotification from '../../components/comments/AtMentionUserNotification';
import TextareaSuggestions, { textareaSuggestionsProps } from '../../hoc/TextareaSuggestions';
import loginRequired from '../../auth/loginRequired';
import { Div } from '../../common/elements';
import { AnnotationThread, CollectionUserEntry } from '../../autogenerated/ZoomBridge';
import StoreListener from '../../store/StoreListener';
import { COLLECTION_USERS, COMMENT_TEXT, PERMISSIONS } from '../../store/Constants';
import Store from '../../store/Store';
import t from '../../i18n/I18n';
import { ThemeSetup } from '../../themes/ThemeSetup';

import '../assets/AddCommentFormStyle.css';
import { isMobile } from '../../util/ScreenUtil';
import { Button } from '../../common';
import KeyboardShortcuts from '../../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../../keyboard-shortcuts/KeydownConfig';
import { KeyCode } from '../../util/Constants';

const debug = require('../../debug/debug')('wc:comments:BrowseCommentForm');

const ToggleState = {
  NONE: 'NONE',
  OPENING: 'OPENING',
  OPEN: 'OPEN',
  CLOSING: 'CLOSING'
};

const getTextarea = (component) => component.refs.textarea;
const getSuggestions = (component) => component.getSuggestions();
const getAcceptSuggestion = (component) => component.acceptSuggestion;
const storeItems = [PERMISSIONS];

@StoreListener(storeItems)
@TextareaSuggestions(getTextarea, getSuggestions, getAcceptSuggestion)
export default class BrowseCommentForm extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    onReply: PropTypes.func,
    onResolved: PropTypes.func,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onReplyClicked: PropTypes.func,
    onReplyEdit: PropTypes.func,
    onReplyRemove: PropTypes.func,
    comment: PropTypes.object,
    global: PropTypes.bool,
    showForm: PropTypes.bool,
    asset: PropTypes.object,
    inFullscreenMode: PropTypes.bool,
    activeId: PropTypes.number,
    [PERMISSIONS]: PropTypes.object,
    onFormShown: PropTypes.func,
    closeOnOutsideClick: PropTypes.bool,
    style: PropTypes.object,
    ...textareaSuggestionsProps
  };

  static defaultProps = {
    global: true,
    showForm: false,
    inFullscreenMode: false,
    closeOnOutsideClick: true,
    onFormShown: _.noop,
    style: {}
  };

  constructor(props) {
    super(props);

    this.state = {
      reply: '',
      isOverflowWindow: false,
      showButtons: false,
      resolveComment: this.props.comment.isResolved(),
      creatorFullName: this.getCreatorFromProps(),
      showForm: props.showForm,
      toggleState: props.global ? ToggleState.OPENING : ToggleState.NONE,
      atMentions: [],
      isSaving: false,
      isCreator: false
    };

    this.onTextChange = this.onTextChange.bind(this);
    this.suggestions = this.getSuggestions();
    this.onReplyClick = this.onReplyClick.bind(this);
    this._scrollNode = document.querySelector('.right-column');
  }

  submitReply = async () => {
    const { comment, onReply } = this.props;
    try {
      if (comment._isSaving) {
        debug('[submitReply()] comment._isSaving. return.');
        return;
      }

      comment._isSaving = true;

      const reply = this.state.reply.trim();
      if (!reply) {
        debug('[submitReply()] reply is empty. return.');
        return;
      }

      await onReply(reply, comment);

      if (this._node) {
        this.setState({ reply: '', showForm: false });
        const scrollNode = this._node.firstChild;
        scrollNode.scrollTop = scrollNode.scrollHeight - scrollNode.clientHeight;
      }
    } catch (err) {
      debug('[submitReply()] error: ', err);
    } finally {
      comment._isSaving = false;
    }
  };

  componentWillMount() {
    this.loadCreatorFullname();
    KeyboardShortcuts.remove('BROWSE_COMMENT_FORM');
  }

  componentDidMount() {
    this.listenClickOutside();
    this.getSuggestions();
    if (this.state.toggleState === ToggleState.OPENING) {
      setTimeout(this.onOpen, 150);
    }
    KeyboardShortcuts.add(new KeydownConfig(('BROWSE_COMMENT_FORM'),this.onClose, [KeyCode.ESCAPE]))
    this.isCreator();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!(this.state.showForm && nextState.showForm)) {
      debug(
        `[shouldComponentUpdate()] not checking for text change because ${JSON.stringify({
          showForm: this.state.showForm,
          nextShowForm: nextState.showForm
        })}`
      );
      return true;
    }

    const textChanged = this.state.reply !== nextState.reply;
    debug('[shouldComponentUpdate] shouldComponentUpdate: ', textChanged);
    return textChanged;
  }

  componentWillReceiveProps(nextProps, nextState) {
    const curr: AnnotationThread = this.props.comment;
    const next: AnnotationThread = nextProps.comment;
    const isResolved = next && next.isResolved();

    if (curr && next && !CommentUtil.compareComments(curr, next) && isResolved !== nextState.resolveComment) {
      debug('[componentWillReceiveProps()] comment isResolved changed. Setting resolveComment=', isResolved);
      this.setState({ resolveComment: isResolved });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.showForm && this.state.showForm) {
      this.focus();
      this.props.onFormShown(this.refs.textarea);
    }

    //if (prevProps[COLLECTION_USERS] !== this.props[COLLECTION_USERS]) {
    //      this.getSuggestions();
    //}
  }

  componentWillUnmount() {
    document.body.style.height = '100%';
    this.stopListeningClicksOutside();
  }

  componentWillUpdate() {}

  onOpen = () => {
    if (!this._node) {
      return;
    }

    this.setState({ toggleState: ToggleState.OPEN });

    const { showForm } = this.state;
    const targetNode = showForm ? this.refs.textarea : findDOMNode(this);
    const scrollNodeRect = this._scrollNode.getBoundingClientRect();
    const targetNodeRect = targetNode.getBoundingClientRect();
    if (targetNodeRect.top < scrollNodeRect.top || targetNodeRect.bottom > scrollNodeRect.bottom) {
      const options = { dest: showForm ? 'CENTER' : 'TOP' };
      animateScroll(this._scrollNode, targetNode, options).then(this.focus);
    } else if (showForm) {
      this.focus();
    }
  };

  setShowFormToThisAndConnectedForms = (isShown) => {
    this.setState({ showForm: isShown, atMentions: [] });
    if (!isShown) {
      Store.put(COMMENT_TEXT, '');
    }
  };

  onClose = () => {
    const { comment, global, onClose } = this.props;
    const id = AnnotationUtil.getRootAnnotation(comment).getCommentId();
    if (!global) {
      onClose(id);
      return;
    }

    const close = () => {
      this.setState({
        toggleState: ToggleState.CLOSING
      });

      setTimeout(() => {
        this.props.onClose(id);
        setTimeout(() => {
          if (this._node) {
            this.setState({ toggleState: ToggleState.NONE });
          }
        }, 100);
      }, 200);
    };

    if (!this._node) {
      return;
    }

    const targetNode = findDOMNode(this);
    const targetNodeTop = targetNode.getBoundingClientRect().top;
    const scrollNodeTop = this._scrollNode.getBoundingClientRect().top;
    if (targetNodeTop < scrollNodeTop) {
      const options = {
        dest: 'TOP',
        speed: Math.abs(scrollNodeTop - targetNodeTop) > 400 ? 'FAST' : 'MEDIUM'
      };
      animateScroll(this._scrollNode, targetNode, options).then(close);
    } else {
      close();
    }
  };

  focus = () => {
    if (this.refs.textarea) {
      this.refs.textarea.focus();
    }
  };

  hasReplies = () => {
    return AnnotationUtil.getReplies(this.props.comment).length > 0;
  };

  listenClickOutside() {
    if (!this.props.closeOnOutsideClick) {
      return;
    }

    this.clickOutsideEvent = 'click.browseCommentForm' + Math.random(500);
    $('body').on(this.clickOutsideEvent, (event) => {
      // if (this.state.showForm) {
      //   return;
      // }

      if ($(event.target).closest('[name="TextareaSuggestions"], .modal-background').length) {
        return;
      }

      if (!$(event.target).closest('#browseCommentFormPosition').length) {
        this.onClose();
      }
    });
  }

  stopListeningClicksOutside() {
    $('body').off(this.clickOutsideEvent);
  }

  getCreatorFromProps() {
    return AnnotationUtil.getCreatorOfThread(this.props.comment);
  }

  loadCreatorFullname() {
    if (!this.getCreatorFromProps()) return;
    ThumbnailUtil.loadUserFullName(this.getCreatorFromProps())
      .then((fullName) => {
        this.setState({ creatorFullName: fullName });
      })
      .catch((errorId) => {
        this.setState({ creatorFullName: 'Anonymous' });
        console.error(errorId);
      });
  }

  onResolveComment() {
    const resolved = !this.state.resolveComment;
    this.props.onResolved(this.props.comment, resolved);
    this.setState({ resolveComment: resolved });
  }

  renderForm() {
    const styles = getStyle();
    return (
      <div style={{ margin: '0 15px 0 10px' }}>
        <textarea
          value={this.state.reply}
          ref="textarea"
          onChange={this.onTextChange}
          placeholder="Reply..."
          style={{
            ...styles.textarea
          }}
        />
        <AtMentionUserNotification atMentions={this.state.atMentions} />
        <div style={{ width: '100%' }}>
          <div onClick={this.submitReply} style={styles.save}>
            {t('SAVE')}
          </div>
          <div
            style={styles.cancel}
            onClick={() => {
              this.setShowFormToThisAndConnectedForms(false);
            }}>
            {t('CANCEL')}
          </div>
        </div>
      </div>
    );
  }

  renderReplyButton() {
    const styles = getStyle();
    return (
      <div className="flex-row justify-end" style={{ margin: `${this.hasReplies() ? '11px' : '1px'} 20px 0 0` }}>
        <div
          style={styles.replyButton}
          onClick={(e) => {
            e.stopPropagation();
            this.setShowFormToThisAndConnectedForms(true);
            if (!this.props.inFullscreenMode && this.props.onReplyClicked)
              this.props.onReplyClicked(this.props.comment);
            setTimeout(this.focus, 210);
          }}>
          {t('REPLY')}
        </div>
      </div>
    );
  }

  @loginRequired
  onReplyClick() {
    this.setShowFormToThisAndConnectedForms(true);
    if (!this.props.inFullscreenMode && this.props.onReplyClicked) {
      this.props.onReplyClicked(this.props.comment);
    }
    setTimeout(this.focus, 210);
  }

  onTextChange(event) {
    const { value } = event.target;
    const atMentions = this.getMentionedUsers(value);
    this.setState({ reply: value, atMentions });
    this.props.onTextChange(event);
    Store.put(COMMENT_TEXT, value);
  }

  acceptSuggestion = (suggestion, text) => {
    const atMentions = this.getMentionedUsers(text);
    this.setState({ reply: text, atMentions });
  };

  getSuggestions = () => {
    const suggestions = (this.suggestions = Store.get(COLLECTION_USERS, []).map((u: CollectionUserEntry) => ({
      value: u._userId,
      label: u._displayName || u._email,
      icon: ThumbnailUtil.avatar(u._userId)
    })));

    return suggestions;
  };

  getMentionedUsers(comment) {
    const usersArray = StringUtil.parseTextForAtMentions(comment, this.suggestions);
    const atMentions = this.suggestions.filter((user) => usersArray.indexOf(user.label) > -1);
    return atMentions;
  }

  onClick = (e: Event) => {
    e.stopPropagation();
  };

  isCreator = () => {
    const isCreator = CommentUtil.isCreator(this.props.comment);
    if (isCreator) {
      this.setState({ isCreator: true });
    }
  };

  getMaxHeight = () => {
    let maxHeight;
    if (this.props.position.top) {
      maxHeight = `${window.gs.height - parseInt(this.props.position.top) - 50}px`;
    } else {
      maxHeight = `${window.gs.height - parseInt(this.props.position.bottom)}px`;
    }
    if (parseInt(maxHeight) > 400 || parseInt(maxHeight) < 0) {
      maxHeight = '400px';
    }
    return maxHeight;
  };

  render() {
    const { global, comment, style } = this.props;
    const styles = getStyle();
    const commentIdx = this.props.comment.getAnnotationLocation().getCommentIndex();
    const { creatorFullName, toggleState, isCreator } = this.state;

    const { canResolveComments, isAdmin, canWriteComments } = this.props[PERMISSIONS];

    const allowEditActions = (canWriteComments && isCreator) || isAdmin;

    const isPrivateNote = AnnotationUtil.isPrivateNote(comment);
    const isResolvedComment = AnnotationUtil.isResolved(comment);

    const activeClass = this.props.activeId === comment.getThreadId() ? 'active' : null;

    return (
      <div
        ref={(node) => (this._node = node)}
        id="browseCommentFormPosition"
        name="BrowseCommentForm"
        className={classNames({
          global,
          opening: toggleState === ToggleState.OPENING,
          closing: toggleState === ToggleState.CLOSING
        })}
        style={{
          ...style,
          ...styles.browseCommentForm,
          width: global ? '100%' : '340px',
          maxHeight: this.getMaxHeight()
        }}
        onMouseEnter={() => this.setState({ showButtons: true })}
        onMouseLeave={() => this.setState({ showButtons: false })}
        onClick={this.onClick}>
        <div style={global ? { paddingRight: '15px' } : styles.scrollView}>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ float: 'left', width: '70px', height: '60px', position: 'relative' }}>
              <div
                style={{
                  ...styles.avatar,
                  backgroundImage: `url(${ThumbnailUtil.avatar(this.getCreatorFromProps())})`
                }}
              />
              {global && (
                <div
                  className={activeClass}
                  style={{
                    ...styles.commentIdOverlay,
                    background: CommentUtil.commentBackgroundByKind(this.props.comment)
                  }}>
                  {commentIdx}
                </div>
              )}
            </div>
            <div style={{ float: 'left', width: 'calc(100% - 70px)' }}>
              <Div title={creatorFullName} style={styles.author}>
                {creatorFullName}
              </Div>
              <Action custom predicates={[() => canResolveComments && !isPrivateNote]}>
                <div
                  style={{
                    ...styles.resolveBtn
                  }}>
                  <Button
                    className="btn-resolve"
                    labelClass="btn-label"
                    text={t('MARK_AS_RESOLVED')}
                    icon={
                      this.state.resolveComment
                        ? ThemeSetup.getImageURL('Icon_Checkmark.svg')
                        : ThemeSetup.getImageURL('Icon_Rectangle_Shape.svg')
                    }
                    onClick={(event) => {
                      event.stopPropagation();
                      this.onResolveComment();
                    }}
                  />
                </div>
              </Action>
              <div style={styles.lastEdit} onClick={CommentUtil.toggleTimeFormat}>
                {CommentUtil.drawEditedOrModified(this.props.comment)}
              </div>
              <div style={styles.text}>{CommentUtil.getRootCommentText(this.props.comment)}</div>
            </div>
          </div>
          <div style={styles.bottomBlock}>
            <Action custom predicates={[() => allowEditActions && !isResolvedComment]}>
              <Div
                style={{
                  ...styles.editBtn,
                  visibility: this.state.showButtons || isMobile() ? 'visible' : 'hidden'
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.onEdit(this.props.comment);
                }}
                title={t('EDIT_COMMENT')}
              />
            </Action>
            <Action custom predicates={[() => allowEditActions && !isResolvedComment]}>
              <Div
                style={{
                  ...styles.removeBtn,
                  visibility: this.state.showButtons || isMobile() ? 'visible' : 'hidden'
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  this.props.onRemove(this.props.comment);
                }}
                title={t('DELETE_COMMENT')}
              />
            </Action>
            <Action custom predicates={[() => FileInfoUtil.isVideo(this.props.asset)]}>
              <div>
                <div style={{ ...styles.timeCodeOfComment, margin: '10px 2px 0px 0px' }} className="fa fa-clock-o" />
                <Div style={styles.timeCodeOfComment} title={t('TIMECODE_OF_COMMENT')}>
                  {moment.utc(AnnotationUtil.getVideOffsetInMilliseconds(this.props.comment)).format('HH:mm:ss.SSS')}
                </Div>
              </div>
            </Action>
          </div>
          <div style={{ marginLeft: '10px' }}>
            <CommentReplies
              key={commentIdx}
              comment={this.props.comment}
              onEdit={this.props.onReplyEdit}
              onRemove={this.props.onReplyRemove}
            />
          </div>
        </div>
        {!isPrivateNote && (
          <Action custom predicates={[() => canWriteComments]}>
            {this.state.showForm ? this.renderForm() : this.renderReplyButton()}
          </Action>
        )}
      </div>
    );
  }
}

function getStyle() {
  return {
    avatar: {
      borderRadius: '50%',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      height: '45px',
      width: '45px',
      position: 'absolute',
      top: '20px',
      left: '10px'
    },
    commentIdOverlay: {
      position: 'absolute',
      top: '15px',
      left: '5px',
      borderRadius: '50%',
      height: '22px',
      width: '22px',
      border: '2px solid #FFF',
      color: '#FFF',
      fontWeight: 500,
      textAlign: 'center',
      fontSize: '11px',
      lineHeight: '18px'
    },
    author: {
      marginTop: '10px',
      color: 'var(--primary-font-color-selected)',
      fontSize: '14px',
      lineHeight: '20px',
      width: '105px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    text: {
      marginTop: '5px',
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--primary-font-color-selected)',
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap'
    },
    bottomBlock: {
      overflow: 'hidden',
      margin: '0 20px 0 10px'
    },
    browseCommentForm: {
      background: 'var(--primary-header-bg)',
      boxShadow: '0 15px 30px -10px rgba(0,0,0,0.20)',
      borderRadius: '2px',
      padding: '0 0 14px 0',
      overflow: 'auto',
      minHeight: '90px',
      color: 'var(--primary-font-color)'
    },
    scrollView: {
      overflowY: 'auto',
      paddingLeft: '15px',
      paddingRight: '15px'
    },
    editBtn: {
      display: 'inline-block',
      float: 'left',
      width: '16px',
      height: '16px',
      backgroundImage: ThemeSetup.getBackgroundURL('edit_asset.svg'),
      margin: '10px 10px 0 0',
      cursor: 'pointer'
    },
    removeBtn: {
      display: 'inline-block',
      float: 'left',
      width: '16px',
      height: '16px',
      backgroundImage: ThemeSetup.getBackgroundURL('trash_red.svg'),
      margin: '10px 19px 0 0',
      cursor: 'pointer'
    },
    resolveBtn: {
      fontSize: 8,
      display: 'inline-block',
      float: 'right',
      // width: '16px',
      height: '16px',
      cursor: 'pointer',
      margin: '-17px 0px 0px 0px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '16px'
    },
    resolvedText: {
      display: 'inline-block',
      float: 'right',
      margin: '-15px 20px 0px 0px',
      fontSize: '8px',
      fontWeight: 600,
      letterSpacing: '1px',
      lineHeight: '10px',
      color: 'var(--primary-font-color)',
      cursor: 'pointer',
      userSelect: 'none',
      WebkitUserSelect: 'none'
    },
    textarea: {
      width: '100%',
      height: '103px',
      border: '1px solid var(--separator-color)',
      marginTop: '8px',
      outline: 'none',
      resize: 'none',
      fontSize: '14px',
      background: 'var(--primary-header-bg)',
      color: 'var(--input-box-font-color)'
    },
    save: {
      display: 'inline-block',
      float: 'left',
      color: 'var(--primary-header-bg)',
      height: '30px',
      lineHeight: '30px',
      marginTop: '10px',
      padding: '0 10px',
      cursor: 'pointer',
      background: 'var(--primary-style-color)',
      borderRadius: '2px',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px'
    },
    cancel: {
      display: 'inline-block',
      float: 'right',
      height: '30px',
      marginTop: '10px',
      lineHeight: '30px',
      cursor: 'pointer',
      color: 'var(--primary-font-color)',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px'
    },
    foldCommentSection: {
      float: 'right',
      cursor: 'pointer'
    },
    comment: {
      display: 'inline-block',
      float: 'left',
      fontSize: '12px',
      fontWeight: 600,
      letterSpacing: '1px',
      color: 'var(--primary-font-color)',
      lineHeight: '13px'
    },
    lastEdit: {
      color: '#B5B5B5',
      fontSize: '11px',
      lineHeight: '13px',
      cursor: 'pointer'
    },
    replyButton: {
      fontSize: '12px',
      fontWeight: 600,
      lineHeight: '15px',
      letterSpacing: '1px',
      color: 'var(--primary-style-color)',
      cursor: 'pointer'
    },
    timeCodeOfComment: {
      display: 'inline-block',
      float: 'left',
      color: '#B5B5B5',
      fontSize: '12px',
      lineHeight: '15px',
      margin: '10px 19px 0 0'
    }
  };
}
